/**
 * Career Listing Filter JS
 * Filters career listings based on job type selection.
 */

class CareerListingFilter {
	constructor() {
		this.filterSelect = document.getElementById( 'career-filter' );
		this.careerItems = document.querySelectorAll( '.career-listing__item' );

		if ( ! this.filterSelect || ! this.careerItems.length ) return;

		this.init();
	}

	init() {
		this.filterSelect.addEventListener( 'change', ( e ) => this.filterJobs( e.target.value ) );
	}

	filterJobs( selectedValue ) {
		// Show all items if no filter selected
		if ( ! selectedValue || selectedValue === '' ) {
			this.careerItems.forEach( item => {
				item.style.display = '';
			} );
			return;
		}

		// Filter items based on selected job type
		this.careerItems.forEach( item => {
			const jobType = item.getAttribute( 'data-job-type' );

			if ( jobType === selectedValue ) {
				item.style.display = '';
			} else {
				item.style.display = 'none';
			}
		} );
	}
}

// Initialize on DOM ready
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', () => new CareerListingFilter() );
} else {
	new CareerListingFilter();
}
